import React from "react";

const SearchIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className="h-6 w-6 text-slate-300"
    fill="none"
    viewBox="0 0 24 24"
    stroke="currentColor"
    strokeWidth={2}
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
    />
  </svg>
);

const Search = ({ search, handleSearch }) => {
  return (
    <div className="md:mx-10">
      {/* <label className="block">
        <input
          value={search}
          onChange={handleSearch}
          className="focus:ring-indigo-500 focus:border-indigo-500 block w-full pl-7 pr-12 sm:text-sm rounded-md py-3 border border-slate-100"
          placeholder="Search..."
        />
      </label> */}
      <div className="relative z-0 w-full mb-6 group">
        <input
          value={search}
          onChange={handleSearch}
          type="text"
          name="search"
          className="block !rounded-none py-3 !px-0 w-full !text-gray-700 text-sm bg-transparent !border-0 !border-b-2 !border-slate-200 appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0 focus:border-blue-600 peer"
          placeholder=" "
          required
        />
        <label
          for="search"
          className="bg-white peer-focus:font-medium absolute text-sm text-slate-400 dark:text-gray-400 duration-300 transform -translate-y-6 scale-75 top-3 px-0 -z-10 focus:z-10 origin-[0] peer-focus:left-0 peer-focus:text-blue-600 peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6"
        >
          Find freelancer...
        </label>
        <div className=" absolute right-1 top-3">
          <SearchIcon />
        </div>
      </div>
    </div>
  );
};

export default Search;
